import BMView from "../View/BMView";

import { BMButton, BMPrimitives, BMText } from "@traveloka/district-bloom";
import { Image, StyleProp, StyleSheet, ViewStyle } from "react-native";
import { ERROR_IMAGE_BASE64 } from "../../assets/error";
import { ImageEntry } from "../../types/resource";

type ButtonProps = {
  label?: string;
  type?: "PRIMARY" | "SECONDARY";
  loading?: boolean;
  onPress?: () => void;
};

type Props = {
  title?: string;
  caption?: string;
  button?: ButtonProps | [ButtonProps, ButtonProps];
  style?: StyleProp<ViewStyle>;
  image?: ImageEntry;
};

export default function ErrorPage({
  title,
  caption,
  style,
  image,
  button,
}: Props) {
  return (
    <BMView align="center" justify="center" style={[styles.wrapper, style]}>
      <BMView align="center" spacing="lg" style={styles.container}>
        <BMView align="center" spacing="lg">
          <BMView style={styles.imageContainer}>
            <Image
              style={styles.image}
              source={{ uri: image?.path ?? ERROR_IMAGE_BASE64 }}
              alt={image?.altText}
            />
          </BMView>
          <BMView spacing="sm">
            <BMText
              variant="titleSmall"
              ink="BMStyleTextInkPrimary"
              numberOfLines={1}
              lineBreakMode="tail"
              style={styles.textAlignCenter}
            >
              {title || "Something went wrong"}
            </BMText>
            <BMText
              variant="paragraphNormal"
              ink="BMStyleTextInkPrimary"
              numberOfLines={2}
              lineBreakMode="tail"
              style={styles.textAlignCenter}
            >
              {caption ||
                "Sorry, our system encounters a bit of trouble. Please check again later."}
            </BMText>
          </BMView>
        </BMView>
        {button ? (
          Array.isArray(button) ? (
            <BMView spacing="xs">
              {button.map((btn, index) => (
                <BMView key={index} style={styles.buttonContainer}>
                  <BMButton
                    label={btn.label || "Refresh"}
                    role={btn.type || "PRIMARY"}
                    size="LARGE"
                    stretchable
                    onPress={() => btn.onPress?.()}
                  />
                </BMView>
              ))}
            </BMView>
          ) : (
            <BMView style={styles.buttonContainer}>
              <BMButton
                loading={button.loading}
                label={button.label || "Refresh"}
                role={button.type || "PRIMARY"}
                size="LARGE"
                stretchable
                onPress={() => button.onPress?.()}
              />
            </BMView>
          )
        ) : null}
      </BMView>
    </BMView>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
  },
  container: {
    marginTop: BMPrimitives.BMSize.md,
    marginBottom: BMPrimitives.BMSize.xl2,
    marginHorizontal: BMPrimitives.BMSize.md,
  },
  textAlignCenter: {
    textAlign: "center",
  },
  imageContainer: {
    marginVertical: 30,
    marginHorizontal: 120,
  },
  image: {
    width: 120,
    height: 120,
  },
  buttonContainer: {
    width: 225,
  },
});
